import { useDropsPageQuery } from "src/components/drops/DropsPage.generated";
import { DropsPageView } from "src/components/drops/DropsPageView";
import { useDocumentTitle } from "src/hooks/useDocumentTitle";
import { useRouteParams } from "src/hooks/useRouteParams";
import { ProjectParams } from "src/routes/routesDef";
import { queryResult } from "src/utils";

export function ProjectDropsPage() {
  const { projectId } = useRouteParams<ProjectParams>();
  useDocumentTitle("Project Drops");
  const query = useDropsPageQuery({ variables: { filter: { project: [projectId] }, entityId: projectId } });

  return queryResult(query, ({ drops }) => <DropsPageView drops={drops} />);
}
